import React, {useEffect, useState} from "react";
import {useTranslate} from "../../../../hooks/translate.hook";
import {Button, Space, Tree, TreeDataNode} from "antd";
import { useParams } from "react-router-dom";
import {Region} from "../../../../models/regions/regions";
import {branchesService} from "../../../../services/branches/branches.service";
import {notifications} from "../../../../services/notifications/notifications";

const toTreeData = (regions: Region[], checked: number[] = []): {selected: number[], tree: TreeDataNode[]} => {

    const tree: TreeDataNode[] = []

    regions.forEach(region => {
        const chld = toTreeData(region.children)

        tree.push({
            title: region.name,
            key: region.id,
            children: chld.tree
        })

        checked.push(...chld.selected)
        if (region.granted && region.children.every(region => region.granted)) {
            checked.push(region.id)
        }
    });

    return {
        tree: tree,
        selected: checked
    };
}

export const BranchDataRegions: React.FC = () => {
    const { branchId } = useParams<{ branchId: string }>();
    const t = useTranslate();

    const [treeData, setTreeData] = useState<TreeDataNode[]>([]);
    const [selectedKeys, setSelectedKeys] = useState<number[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const reload = () => {
        setLoading(true);
        branchesService.getRegions(branchId!).then(result => {
            const frm = toTreeData(result);
            setTreeData(frm.tree)
            setSelectedKeys(frm.selected)
            setLoading(false);
        })
    }

    const updateFromSource = () => {
        setLoading(true);
        branchesService.updateRegionsFromSource(branchId!).then(() => {
            notifications.successfully();
            reload()
        });
    }

    const save = () => {
        setLoading(true);
        branchesService.saveRegions(branchId!, selectedKeys).then(() => {
            notifications.successfully();
            reload()
        });
    }

    useEffect(() => {
        reload();
    }, []);

    return (
        <Space direction="vertical" size={[20, 20]}>
            <Button type="primary" onClick={updateFromSource} disabled={loading}>
                {t("BRANCH.DATA.REGIONS.UPDATE-FROM-SOURCE")}
            </Button>
            {treeData.length > 0 ? (
                <>
                    <Tree
                        checkable
                        treeData={treeData}
                        checkedKeys={selectedKeys}
                        onCheck={(keys) => setSelectedKeys(keys as number[])}
                    />
                    <Button type="primary" onClick={save} disabled={loading}>
                        {t("SAVE")}
                    </Button>
                </>
            ) : null}
        </Space>
    );
};
